import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { styleWithVars } from "@lib/cssVars";
import { DensityChartTracks } from "./DensityChartTracks";
import styles from "./DensityChartBeforeStart.module.scss";

interface DensityChartBeforeStartProps {
    zoneCount: number;
    bucketCount: number;
    gapShare: number;
    /** Shown on hover, and names the zone for assistive tech. */
    message?: string;
}

/**
 * The zone before the history start: the chart's tracks, blurred, fading in
 * from the history start backward on mount. Hovering it shows `message` next
 * to the cursor. It takes no clicks.
 */
export function DensityChartBeforeStart({
    zoneCount,
    bucketCount,
    gapShare,
    message,
}: DensityChartBeforeStartProps) {
    return (
        <div
            className={styles.zone}
            data-full={zoneCount >= bucketCount}
            style={styleWithVars({
                "--zone-width": `${(zoneCount / bucketCount) * 100}%`,
            })}
        >
            <DensityChartTracks
                count={zoneCount}
                gapShare={gapShare}
                className={styles.tracks}
                trackClassName={styles.track}
            />
            {message && (
                <Tooltip content={message} trackCursorAxis="both">
                    <div
                        className={styles.hitArea}
                        role="img"
                        aria-label={message}
                    />
                </Tooltip>
            )}
        </div>
    );
}
